import React, { useState } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";

const ImageCrop = ({ image, onImageSave }) => {
    const [cropper, setCropper] = useState(null);

    const handleCrop = () => {
        if (cropper) {
            const croppedImage = cropper.getCroppedCanvas().toDataURL();
            onImageSave(croppedImage);
        }
    };

    return (
        <div>
            {image && (
                <Cropper
                    style={{ height: 300, width: "100%" }}
                    src={image}
                    viewMode={1}
                    guides={true}
                    cropBoxResizable={true}
                    dragMode="move"
                    onInitialized={(instance) => setCropper(instance)}
                />
            )}
            <button onClick={handleCrop} className="btn btn-primary mt-3">
                Guardar Imagen Recortada
            </button>
        </div>
    );
};

export default ImageCrop;
